import { useEffect, useState } from 'react';
import { ethers, BigNumber } from 'ethers';
import { Box, Button, Flex, Input, Text, Image, Stack } from '@chakra-ui/react';
import Wolf from "./assets/hidden.gif";
import WWFTitle from "./assets/tempwacky.png";

import wackyWolfFriendsNFT from './WackyWolfFriendsNFT.json';
/*
const preMintNumber = {"0xd967F16fDf5fFf7297db5a716F70CeC78D4F3063": 10,
        "0x47eC4481Dda0B5fC22f4fc364aB195f9E3d97551": 2,
        "0x81D8a628B16DeEfd457d37C8feE090fc4B3b0a12": 3,
        "0xECF78B09d78DBD41FF1954837e849029CD43CC6C": 5,
        "0xE126cfe063aC3b6dd02DC47c3E266e9099A95ae1": 1,
        "0x9e89bc62e551da25068308cf6a5a3288b8ef623b": 12,
        "0x576a0169cba7dbd78080E9E1804aed2d0acC5d75": 5,
        "0x44Ee58b417Abf50f7A8710B2Da132096792c9E56": 2,
        "0xC3117AAa8D8ae98965b94A2E980E6166c20a88CA": 1,
        "0xBCa76274537d2718b90892Ea09ffA5C0e8228a39": 3,
        "0x292B8118fb4153d4883FA2FbF758688EF16b686B": 7,
        "0xB62c2C07fF90968B8F5B8949b23654d30f4BD353": 1,
        "0x7bE77eAeFAae7843f5A9Af2A4be7aF3C38770c8C": 1,
        "0x30817C20EBc30dEF5f45f9598167d167D8b9D57c": 5,
        "0xA9e72Fb863cab3De32e68b9f990D3F894d7Fa9E1": 113,
        "0x852cB7b3937EA03e26A0C37160c50b17454926F4": 1,
        "0x65AAf6d3fAe0E3BC43bB7cd48f4bb1B105Ab2b7E": 1,
        "0x2B3740E7553fA04B2328D0a8aa3aD92755f3698a": 11,
        "0x6480525B444A3F788151d79d3E9c65E3eB0f3e3e": 11,
        "0xD8AAF06c2914c2f5d246DED9676e70176f172a94": 2,
        "0x3b57C1c4613bCd9e82443C4eC6D8aBA259Bc612a": 2,
        "0x91EdfE19E7b6f6e24387806a162C0a8ce787b02a": 1,
        "0x852f61558733f8E078e0fAf7868B1c728A4d7C53": 29,
        "0x156F98D4b1ef8E754d37f6493eeE7aF9B239f791": 9,
        "0xE201bE43E1C7f4C739041c543e641e0843C3C334": 4,
        "0x9a96FC2698ec47f007c6FA84B897dc0Aa34B606d": 17,
        "0x149Fd2056b0b85D33BF600A53bD4151C9e9aFd94": 8,
        "0xeaAabdE637C44015A5B37059920Bf8C3939D3901": 1,
        "0xB1A362a130A302EbC6caC0370Bbc80a406B78282": 32,
        "0x903aFd4A2130198B38775ca214e499DCFbfd37A2": 1,
        "0x96D8f721E4D6EcE28cbFA0A9d42E2B29AF42f069": 1,
        "0x353cd03F4961179abD6dDd013fEfF1B76FC60134": 1,
        "0xD028669Ab4bE52C90Ca83a4eF5c1c827e14706bC": 2,
        "0x356E319edEA99a3f1863caf1347247685F6C420C": 5,
        "0x9600D27Eb28c6C0715ca675056C5D46346290F0b": 1,
        "0x2D8C24588c518ed8cb9e8D6F91ee77E6D091c031": 3,
        "0xEE39d634c1056191F2A039712640098c6919c387": 11,
        "0x2fa59451b6ea2D5bCc58397dF4A085B1e7F7C2f7": 1};
*/
/* replace address with actual Wacky Wolves Contract Address */
const wackyWolfFriendsNFTAddress = "0x9Cf21ff0f546d4E47Ff3e4258e3D12844331C3c8";

/* If Website is paused, set to true, otherwise set to false */
const isMintPaused = false;

/* PRE-WHITELIST PERIOD */
/*
const mintState = 0;
const countTime = `2022-04-15T16:00:00Z`;   
const mintPrice = 8;
const maxPerMint = 1;
*/

/* DURING WHITELIST SALE PERIOD */
/*
const mintState = 1;
const countTime = `2022-04-17T16:00:00Z`;
const mintPrice = 8;
const maxPerMint = 3;
*/

/* DURING PUBLIC SALE PERIOD */

const mintState = 2;
const countTime = `2022-01-01T00:00:00Z`;
const mintPrice = 12;
const maxPerMint = 10;


/* SOLD-OUT PERIOD */
/*
const mintState = 3;
const countTime = `2022-01-01T00:00:00Z`;
const mintPrice = 20;
const maxPerMint = 1;
*/

const MainMint = ({ accounts, setAccounts }) => {
    
    const [mintAmount, setMintAmount] = useState(1);
    const isConnected = Boolean(accounts[0]);
  /*  const tempPreMint = preMintNumber[ethers.utils.getAddress(accounts[0])];*/
    const [isAddressWL, setIsAddressWL] = useState(false);
    const [message, setMessage] = useState("");
    const [checkWLCount, setCheckWLCount] = useState(false);
    const [howManyAddressMinted, setHowManyAddressMinted] = useState(0);
    const [totalMinted, setTotalMinted] = useState(0);


    async function handleMint() {
        if (window.ethereum) {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const contract = new ethers.Contract(
                wackyWolfFriendsNFTAddress,
                wackyWolfFriendsNFT.abi,
                signer);
            try {
                const response  = await contract.mint(BigNumber.from(mintAmount), {
                    value: ethers.utils.parseEther((mintPrice * mintAmount).toString()),
                });
                console.log('response: ', response);
                setMessage("Success! You'll have your Wolves shortly!");
            }   catch (err) {
                console.log('error: ', err);
                setMessage(err.data.message.slice(5, 47));
            }
        }
    };

    const handleDecrement = () => {
        if (mintAmount <= 1) return;
        setMintAmount(mintAmount - 1);
    };

    const handleIncrement = () => {
        if (mintState === 1) {
            if (howManyAddressMinted === maxPerMint) {
                setMintAmount(0);
            } else {
                if (mintAmount >= (maxPerMint - howManyAddressMinted)) return;
                setMintAmount(mintAmount + 1);
            }
        } else {
            if (mintAmount >= maxPerMint) return;
            setMintAmount(mintAmount + 1);
        }
    };

    const checkTotal = async () => {
        if (window.ethereum) {
            const chainId = await window.ethereum.request({
                method: "eth_chainId",
                });
            if (chainId === '0x89') {
                const provider = new ethers.providers.Web3Provider(window.ethereum);
                const contract = new ethers.Contract(
                    wackyWolfFriendsNFTAddress,
                    wackyWolfFriendsNFT.abi,
                    provider);
                setTotalMinted(await contract.totalSupply());
                if (isConnected) {
                    setHowManyAddressMinted((await contract.balanceOf(accounts[0])));
                } 
            } else {
                const provider = new ethers.providers.JsonRpcProvider('https://polygon-rpc.com');
                const contract = new ethers.Contract(
                    wackyWolfFriendsNFTAddress,
                    wackyWolfFriendsNFT.abi,
                    provider);
                setTotalMinted(await contract.totalSupply());
            }
        } else {
            const provider = new ethers.providers.JsonRpcProvider('https://polygon-rpc.com');
            const contract = new ethers.Contract(
                wackyWolfFriendsNFTAddress,
                wackyWolfFriendsNFT.abi,
                provider);
            setTotalMinted(await contract.totalSupply());
        }
    };

    const checkWLStatus = async () => {
        if (window.ethereum) {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const contract = new ethers.Contract(
                wackyWolfFriendsNFTAddress,
                wackyWolfFriendsNFT.abi,
                provider);
            setIsAddressWL(await contract.isWhitelisted(accounts[0]));
            setCheckWLCount(true);
            checkTotal();
        }
    };

    useEffect(() => {
        checkTotal();
    }, [totalMinted]);

    const calculateTimeLeft = () => {

        const difference = +new Date(countTime) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                d: Math.floor(difference / (1000 * 60 * 60 * 24)).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
                }),
                h: Math.floor((difference / (1000 * 60 * 60)) % 24).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
                }),
                m: Math.floor((difference / 1000 / 60) % 60).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
                }),
                s: Math.floor((difference / 1000) % 60).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
                }),
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearTimeout(intervalId);
    },[]);

    const timerComponents = [];

    Object.keys(timeLeft).forEach((interval) => {

        timerComponents.push(
            <span key={interval}>
                {timeLeft[interval]}{interval}{" "}
            </span>
        );
    });

    return (
        <Flex justify='center' align='center' height='auto' >
            <Box
                width={['90vw', '70vw', '55vw', '35vw']}
                height='auto'
                backgroundColor='#83EDF3'
                borderRadius='15px'
                boxShadow='0px 7px 7px 5px #0F0F0F'
                color='black'
                fontFamily='inherit'
                fontSize='1.5vw'
                padding='10px'
                margin='50px 15px'
                backgroundcolor='transparent'
            >
                <div>
                    <Stack direction='row' align='center' justify='center'>
                        <Image width={['80vw', '60vw', '45vw', '25vw']} margin='10px 0px 5px' src={WWFTitle} />
                    </Stack>
                    <Stack direction='row' align='center' justify='center'>
                        <Image boxSize={['25vw', '20vw', '15vw', '10vw']} borderRadius='200px' margin='5px 0px' src={Wolf} />
                        <Text
                            fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                            fontWeight='bold'
                        >
                            {totalMinted.toString()}/3500
                        </Text>
                        <Image boxSize={['25vw', '20vw', '15vw', '10vw']} borderRadius='200px' margin='5px 0px' src={Wolf} />
                    </Stack>
                    <Text
                        fontSize={['4.5vw', '4vw', '3vw', '1.5vw']}
                        fontStyle='italic'
                        letterSpacing='-5.5%'
                        fontFamily='inherit'
                        margin='5px 0px'
                    >
                        Mint Your Wacky Wolf Friend, Part of the Wacky Wildlife Friends NFT Collection!
                    </Text>
                {
                isMintPaused
                ?   mintState !== 3
                    ?   (
                        <div>
                            <Text
                                fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                color='red'
                                fontWeight='bold'
                                fontFamily='inherit'>
                                CONTRACT IS PAUSED
                            </Text>
                        </div>
                        )
                    :   null
                :  
                    mintState === 0
                    ?   (
                        <div>
                            <Text
                                fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                letterSpacing='-5.5%'
                                fontWeight='bold'
                                fontFamily='inherit'
                                margin='5px 0px'>
                                The Whitelist Sale is in
                            </Text>
                            <Box
                                backgroundColor='black'
                                borderRadius='15px'
                                boxShadow='0px 2px 2px 1px #0F0F0F'
                                color='white'
                                fontFamily='inherit'
                                fontSize={['5.75vw', '4.25vw', '2.75vw', '1.55vw']}
                                padding='0px'
                                margin='5px 15px'>
                                {timerComponents.length ? timerComponents : <span>Whitelist Sale Active Momentarily!</span>}
                            </Box>
                        </div>
                        )
                    : 
                        mintState === 1
                        ?   (
                            <div>
                                <Text
                                    fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                    letterSpacing='-5.5%'
                                    fontWeight='bold'
                                    fontFamily='inherit'
                                    margin='5px 0px'>                                    
                                    Whitelist Sale NOW! Public Sale in 
                                </Text>
                                <Box
                                    backgroundColor='black'
                                    borderRadius='15px'
                                    boxShadow='0px 2px 2px 1px #0F0F0F'
                                    color='white'
                                    fontFamily='inherit'
                                    fontSize={['5.75vw', '4.25vw', '2.75vw', '1.55vw']}
                                    padding='0px'
                                    margin='5px 15px'>
                                    {timerComponents.length ? timerComponents : <span>Public Sale Active Momentarily!</span>}
                                </Box>
                            </div>
                            )
                        :
                            mintState === 2
                            ?   (
                                <div>
                                <Text
                                    fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                    letterSpacing='-5.5%'
                                    fontWeight='bold'
                                    fontFamily='inherit'
                                    margin='5px 0px'>
                                    Public Sale is NOW! 
                                </Text>
                                </div>
                                )
                            :
                                null
                }

                {
                isMintPaused
                ?   null
                :
                    !isConnected && mintState < 3
                    ?   (
                        <div>
                            <Text
                                fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                fontWeight='bold'
                                color='red'
                                letterSpacing='-5.5%'
                                fontFamily='inherit'>
                                Please Connect Your Wallet
                            </Text>
                        </div>
                        )
                    : 
                        mintState === 0
                        ?   isAddressWL
                            ?   (
                                <div>
                                    <Text
                                        fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                        fontWeight='bold'
                                        color='green'
                                        letterSpacing='-5.5%'
                                        fontFamily='inherit'>
                                        Congratulations, Your Wallet Address is Whitelisted! &#128526;
                                    </Text>
                                </div>
                                )
                            :   
                                !isAddressWL && checkWLCount
                                ?   (
                                    <div>
                                        <Text
                                            fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                            fontWeight='bold'
                                            letterSpacing='-5.5%'
                                            fontFamily='inherit'
                                            color='red'>
                                            Sorry, Your Wallet Address isn't Whitelisted! &#128558;
                                        </Text>
                                    </div>
                                    )
                                :
                                    (
                                    <div>
                                        <Button
                                            fontSize={['6vw', '4.5vw', '3vw', '1.5vw']} 
                                            backgroundColor='#D6517D'
                                            borderRadius='15px'
                                            boxShadow='0px 2px 2px 1px #0F0F0F'
                                            color='black'
                                            cursor='pointer'
                                            fontFamily='inherit'
                                            padding='10px'
                                            margin='14px 0px 10px'
                                            onClick={checkWLStatus}>
                                            Check Whitelist Status
                                        </Button>
                                    </div>
                                    )
                        :   mintState === 1 
                            ?   isAddressWL
                                ?   howManyAddressMinted < 3
                                    ?   (
                                        <div>
                                            <Text
                                                fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                                fontWeight='bold'
                                                color='black'
                                                letterSpacing='-5.5%'
                                                fontFamily='inherit'>
                                                You've Minted {howManyAddressMinted.toString()} of {maxPerMint} Wolves Allowed During Whitelist.
                                            </Text>
                                            <Flex align='center' justify='center'>
                                                <Button 
                                                    backgroundColor='#D6517D'
                                                    borderRadius='15px'
                                                    boxShadow='0px 2px 2px 1px #0F0F0F'
                                                    color='black'
                                                    cursor='pointer'
                                                    fontFamily='inherit'
                                                    padding='15px'
                                                    marginTop='10px'
                                                    fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                                                    onClick={handleDecrement}
                                                >
                                                    -
                                                </Button>
                                                <Input 
                                                    readOnly
                                                    fontFamily='inherit'
                                                    width='80px'
                                                    height='40px'
                                                    textAlign='center'
                                                    paddingLeft='19px'
                                                    marginTop='10px'
                                                    type='number'
                                                    fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                                                    value={mintAmount}
                                                />
                                                <Button 
                                                    backgroundColor='#D6517D'
                                                    borderRadius='15px'
                                                    boxShadow='0px 2px 2px 1px #0F0F0F'
                                                    color='black'
                                                    cursor='pointer'
                                                    fontFamily='inherit'
                                                    padding='15px'
                                                    marginTop='10px'
                                                    fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                                                    onClick={handleIncrement}
                                                >
                                                    +
                                                </Button>
                                            </Flex>
                                            <Button 
                                                backgroundColor='#D6517D'
                                                fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                                                fontWeight='bold'
                                                borderRadius='15px'
                                                boxShadow='0px 2px 2px 1px #0F0F0F'
                                                color='black'
                                                cursor='pointer'
                                                fontFamily='inherit'
                                                padding='10px'
                                                margin='15px 0px 5px'
                                                onClick={handleMint}
                                            >
                                                MINT ({mintPrice * mintAmount} MATIC)
                                            </Button>                                    
                                        </div>
                                        )
                                    :
                                        (
                                        <div>
                                            <Text
                                                fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                                fontWeight='bold'
                                                color='red'
                                                letterSpacing='-5.5%'
                                                fontFamily='inherit'>
                                                You've Already Minted {maxPerMint} Wolves!
                                            </Text>
                                        </div>
                                        )
                                :   
                                    !isAddressWL && checkWLCount
                                    ?   (
                                        <div>
                                            <Text
                                                fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                                fontWeight='bold'
                                                letterSpacing='-5.5%'
                                                fontFamily='inherit'
                                                color='red'>
                                                Sorry, Your Wallet Address isn't Whitelisted! &#128558;
                                            </Text>
                                        </div>
                                        )
                                    :   
                                        (
                                        <div>
                                            <Button
                                                fontSize={['6vw', '4.5vw', '3vw', '1.5vw']} 
                                                backgroundColor='#D6517D'
                                                borderRadius='15px'
                                                boxShadow='0px 2px 2px 1px #0F0F0F'
                                                color='black'
                                                cursor='pointer'
                                                fontFamily='inherit'
                                                padding='10px'
                                                margin='14px 0px 10px'
                                                onClick={checkWLStatus}>
                                                Check Whitelist Status
                                            </Button>
                                        </div>
                                        )
                            :   mintState === 2
                                ?   (
                                    <div>
                                        <Box
                                            backgroundColor='black'
                                            borderRadius='15px'
                                            boxShadow='0px 2px 2px 1px #0F0F0F'
                                            color='white'
                                            fontFamily='inherit'
                                            fontSize={['6.5vw', '5vw', '3.5vw', '2vw']}
                                            padding='0px'
                                            margin='5px 15px'>
                                            {maxPerMint} Wolves Allowed per Transaction
                                        </Box>
                                        <Flex align='center' justify='center'>
                                            <Button 
                                                backgroundColor='#D6517D'
                                                borderRadius='15px'
                                                boxShadow='0px 2px 2px 1px #0F0F0F'
                                                color='black'
                                                cursor='pointer'
                                                fontFamily='inherit'
                                                padding='15px'
                                                marginTop='10px'
                                                fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                                                onClick={handleDecrement}
                                            >
                                                -
                                            </Button>
                                            <Input 
                                                readOnly
                                                fontFamily='inherit'
                                                width='100px'
                                                height='40px'
                                                textAlign='center'
                                                paddingLeft='19px'
                                                marginTop='10px'
                                                type='number'
                                                fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                                                value={mintAmount}
                                            />
                                            <Button 
                                                backgroundColor='#D6517D'
                                                borderRadius='15px'
                                                boxShadow='0px 2px 2px 1px #0F0F0F'
                                                color='black'
                                                cursor='pointer'
                                                fontFamily='inherit'
                                                padding='15px'
                                                marginTop='10px'
                                                fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                                                onClick={handleIncrement}
                                            >
                                                +
                                            </Button>
                                        </Flex>
                                        <Button 
                                            backgroundColor='#D6517D'
                                            fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                                            fontWeight='bold'
                                            borderRadius='15px'
                                            boxShadow='0px 2px 2px 1px #0F0F0F'
                                            color='black'
                                            cursor='pointer'
                                            fontFamily='inherit'
                                            padding='10px'
                                            margin='15px 0px 5px'
                                            onClick={handleMint}
                                        >
                                            MINT ({mintPrice * mintAmount} MATIC)
                                        </Button>                                    
                                    </div>
                                    )
                                :
                                    null
                }
                {
                isConnected && mintState < 3
                ?   (
                    <div>
                        <Text
                            fontSize={['6vw', '4.5vw', '3vw', '1.5vw']}
                            color='black'
                            letterSpacing='-5.5%'
                            fontFamily='inherit'>
                            { message }
                        </Text>
                        <Text
                            fontSize={['3.6vw', '2.8vw', '2.2vw', '1.3vw']}
                            margin='10px 0px 0px'
                            color='black'
                            letterSpacing='-5.5%'
                            fontFamily='inherit'
                            fontWeight='bold'>
                            { accounts[0] }
                        </Text>
                    </div>
                    )
                :   mintState === 3
                    ?   (
                        <div>
                            <Text
                            fontSize={['5.8vw', '4.5vw', '3.5vw', '2vw']}
                                letterSpacing='-5.5%'
                                fontWeight='bold'
                                fontFamily='inherit'>
                                &#128525; SOLD OUT! THANK-YOU! &#128525;
                            </Text>
                        </div>
                        )
                    : null
                }
                </div>
            </Box>
        </Flex>
    );
};

export default MainMint;